import Vue from 'vue';
import VueRouter, { NavigationGuard } from 'vue-router';
import store from '@/store';
import Home from '@/views/Home.vue';
import Overview from '@/views/Overview.vue';
import Chapter from '@/views/Chapter.vue';
import Result from '@/views/Result.vue';
import {RouteName, SiteId} from '@/enums';
import {isVariationDiet, isVariationMunicipality} from "@/utils/common";

Vue.use(VueRouter);

const savedScrolls: Map<string, { x: number; y: number }> = new Map<string, { x: number; y: number }>();

const routerGuard: NavigationGuard = (to, from, next) => {

	// wait one tick for store to initialize
	Vue.nextTick(() => {
		if (from.name === RouteName.RESULT && store.getters.allThemesFinished) {
			console.log('routerGuard1');
			next(false);
			return;
		}

		if (to.name === RouteName.RESULT && !store.getters.allThemesFinished) {
			console.log('routerGuard2');
			next(false);
			return;
		}

		/* if (isVariationMunicipality() && !store.state.gateSurveyFinished && to.name != RouteName.HOME && to.name != RouteName.GATE_SURVEY && to.name != RouteName.PRE_QUESTION_SURVEY && to.name != RouteName.USER_SURVEY) {
			console.log('routerGuard3');
			next('/');
			return;
		} */

		if (to.name === RouteName.USER_SURVEY && !isVariationDiet() ) {
			// people that is doing the municipality version should not be able to see the all about diet user survey
			console.log('routerGuard4');
			next('/');
			return;
		}

		if (to.name === RouteName.OUTRO && !isVariationMunicipality() ) {
			// people that is doing the municipality version should not be able to see the all about diet user survey
			console.log('routerGuard5');
			next('/');
			return;
		}

		if (to.name === RouteName.GATE_SURVEY && !isVariationMunicipality() ) {
			// people that is doing the municipality version should not be able to see the gatesurvey
			console.log('routerGuard6');
			next('/');
			return;
		}

		next();
	});


};

const routes = [
	{
		path: '/',
		name: RouteName.HOME,
		component: Home,
		meta: { currentPage: RouteName.HOME }
	},
	{
		path: '/gate-survey',
		name: RouteName.GATE_SURVEY,
		component: Home,
		meta: { currentPage: RouteName.GATE_SURVEY }
	},
	{
		path: '/user-survey',
		name: RouteName.USER_SURVEY,
		component: Home,
		meta: { currentPage: RouteName.USER_SURVEY }
	},
	{
		path: '/pre-question-survey',
		name: RouteName.PRE_QUESTION_SURVEY,
		component: Home,
		meta: { currentPage: RouteName.PRE_QUESTION_SURVEY }
	},
	{
		path: '/overview',
		name: RouteName.OVERVIEW,
		component: Overview
	},
	{
		path: '/:domainId/:chapterId',
		name: RouteName.CHAPTER,
		component: Chapter
	},
	{
		path: '/info',
		name: RouteName.OUTRO,
		component: Home,
		meta: { currentPage: RouteName.OUTRO }
	},
	{
		path: '/result',
		name: RouteName.RESULT,
		component: Result
	}
];

const router = new VueRouter({
	routes,
	scrollBehavior: (to, from, savedPosition) => {
		if (from.name == RouteName.HOME) {
			return { x: 0, y: 0 };
		}

		if (from.name == RouteName.OVERVIEW) {
			saveScroll(RouteName.OVERVIEW);
		}

		if (to.name && savedScrolls.has(to.name)) {
			return savedScrolls.get(to.name);
		}
	}
});

router.beforeEach(routerGuard);

export function saveScroll(routeName: string) {
	if (routeName) {
		savedScrolls.set(routeName, { x: 0, y: window.pageYOffset });
	}
}

export default router;
